import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MainLayout } from "./layouts/MainLayout";
import DashboardPage from "./features/dashboard/pages";
import TaskListPage from "./features/dashboard/pages/taskList";
import AlgorithmConfigPage from "./features/algorithm/pages/algoritmhPage";
import LoginPage from "./features/login/pages/Login";
import EventListPage from "./features/eventList/pages";
import { ProtectedRoute } from "./components/protectedRoute";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected */}
        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/tasks" element={<TaskListPage />} />
            <Route path="/config" element={<AlgorithmConfigPage />} />
            <Route path="/event" element={<EventListPage />} />
          </Route>
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
